import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import LoadingOverlay from 'react-loading-overlay'
import { Strings, checkAdminUser } from '../configs'
import { useHistory } from 'react-router-dom'
import '../styles/Login.css'
import bearImage from '../assets/whitebearlazy.png'
import { signInWithFacebook, signInWithGoogle, getSignData, addUser } from '../configs/FireBase'
import { updateUser, setFirstTimeTutorial, setIsShowLoginModal } from '../store/actions'
import { logEvent } from '../configs/Analytics'

export default function Login() {
  const dispatch = useDispatch()
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    setIsLoading(true)
    getSignData((user) => saveUserData(user))
    logEvent('Open Login Page')
  }, [])
  function backToHomePage() {
    history.push('home')
  }
  function onClickFBLogin() {
    setIsLoading(true)
    signInWithFacebook((user) => saveUserData(user))
  }
  function onClickGoogleLogin() {
    setIsLoading(true)
    signInWithGoogle((user) => saveUserData(user))
  }
  async function saveUserData(user) {
    if (user) {
      dispatch(setFirstTimeTutorial(false))
      dispatch(setIsShowLoginModal(false))
      const currentUserData = user.phoneNumber ? {
        displayName: user.displayName,
        email: user.providerData[0].email || '',
        phoneNumber: user.phoneNumber,
        photoURL: getUserPhotoUrl(user.photoURL, user.accessToken),
        accessToken: user.accessToken,
        uid: user.uid,
      } : {
        displayName: user.displayName,
        email: user.providerData[0].email || '',
        photoURL: getUserPhotoUrl(user.photoURL, user.accessToken),
        accessToken: user.accessToken,
        uid: user.uid,
      }
      dispatch(updateUser(currentUserData))
      await addUser(currentUserData)
      const isAd = await checkAdminUser(user)
      if (isAd) {
        history.push('admin')
        setIsLoading(false)
      } else {
        backToHomePage()
        setIsLoading(false)
      }
    } else {
      setIsLoading(false)
    }
  }
  function getUserPhotoUrl(photoURL, accessToken) {
    if (accessToken) {return `${photoURL}?access_token=${accessToken}&type=large`}
    return photoURL
  }
  return (
    <LoadingOverlay
      active={isLoading}
      spinner
      text='Login...'
    >
      <div id="app">
        <div className="app-container">
          <div className="navigation-bar">
            <a onClick={() => history.goBack()}>
              <svg viewBox="0 0 22 17" className="back-button">
                <g stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(-3, -6)">
                  <path d="M5.78416545,15.2727801 L12.9866648,21.7122915 C13.286114,22.0067577 13.286114,22.4841029 12.9866648,22.7785691 C12.6864297,23.0738103 12.200709,23.0738103 11.9004739,22.7785691 L3.29347136,15.0837018 C3.27067864,15.0651039 3.23845445,15.072853 3.21723364,15.0519304 C3.06240034,14.899273 2.99480814,14.7001208 3.00030983,14.5001937 C2.99480814,14.3002667 3.06240034,14.1003396 3.21723364,13.9476821 C3.23845445,13.9275344 3.2714646,13.9345086 3.29425732,13.9166857 L11.9004739,6.22026848 C12.200709,5.92657717 12.6864297,5.92657717 12.9866648,6.22026848 C13.286114,6.51628453 13.286114,6.99362977 12.9866648,7.288096 L5.78416545,13.7276073 L24.2140442,13.7276073 C24.6478918,13.7276073 25,14.0739926 25,14.5001937 C25,14.9263948 24.6478918,15.2727801 24.2140442,15.2727801 L5.78416545,15.2727801 Z"></path>
                </g>
              </svg>
            </a>
            <div className="login-title">
              <div className="login-text">{Strings.login}</div>
            </div>
          </div>
          <div>
            <div className="form-container">
              <div className="logo-container">
                <img className="logo" src={bearImage} />
              </div>
              <div>
                <button className="fb-container" onClick={onClickFBLogin}>
                  <div className="fb-icon-content">
                    <div className="fb-icon"></div>
                  </div>
                  <span className="fb-text">{Strings.continueWithFacebook}</span>
                </button>
                <div className="or-container">
                  <div className="or-line"></div>
                  <div className="or-text">{Strings.or.toUpperCase()}</div>
                  <div className="or-line"></div>
                </div>
                <button className="gg-container" onClick={onClickGoogleLogin}>
                  <div className="gg-icon-content"><div className="gg-icon"></div>
                  </div><span className="gg-text">{Strings.continueWithGoogle}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  )
}